import * as React from 'react';
import styled from 'styled-components';
import { media, Icon } from '@packages/ui';
import { Arrow, ArrowProps } from '../Arrow/Arrow';

// TODO: fix z index
const ArrowLeftStyled = styled(Arrow).attrs({ 'data-testid': 'arrow-left' })<{ elevation: number | number[] }>`
  border-radius: 45%;
  padding-left: 7px;
  position: absolute;
  bottom: calc(50% - 20px);
  z-index: 100;
  left: 0px;
  ${media.to.md`
    display: none;
  `}
`;

export const ArrowLeft: React.FC<ArrowProps & { disabled?: boolean; onClick?: (event: MouseEvent) => void }> = ({
  className,
  disabled,
  onClick,
}) => {
  return (
    <ArrowLeftStyled disabled={disabled} elevation={2} className={className} onClick={onClick as any}>
      <Icon size={16} color="white" name="chevronLeft" />
    </ArrowLeftStyled>
  );
};
